import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { t, defineMessages } from '@sm/intl';

const DEFAULT_COPY = defineMessages({
  PAGE: {
    id: 'PageHeader.Page',
    defaultMessage: 'Page',
    description: '[Type: Text][Vis.: low] - Page Text',
  },
});

const useStyles = createUseStyles(({ spacing }) => ({
  pageHeaderHeading: {
    padding: [spacing[4], 0, spacing[6]],
  },
  pageHeaderSeparator: {
    opacity: 0.2,
    borderStyle: 'solid',
  },
  pageHeaderCount: {
    textAlign: 'right',
  },
}));

const PageHeader = ({ currentPage, totalPages }) => {
  const { pageHeaderCount, pageHeaderHeading, pageHeaderSeparator } = useStyles();
  return (
    <h4 className={pageHeaderHeading} data-testid="PageHeader__Container">
      <hr className={pageHeaderSeparator} />
      <div className={pageHeaderCount}>
        {t(DEFAULT_COPY.PAGE)} {currentPage}/{totalPages}
      </div>
    </h4>
  );
};

PageHeader.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

export default PageHeader;
